import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAlertModel as AlertModel, IAlertMessage as AlertMessage} from 'models/AlertModel';
import { RootState } from 'store/store';

const createInitialState = (): (AlertModel | null) => null;

const name = 'alert';
const initialState = createInitialState();

export const alertSlice = createSlice({
    name,
    initialState,
    reducers:
    {
        success: (state, action) => {
            state = {
                alertType: "success",
                icon: "check-circle",
                alertMessage: {
                    message: action?.payload.message,
                    showAfterRedirect: action?.payload.showAfterRedirect
                }
            };
            return state;
        },
        danger: (state, action: PayloadAction<AlertMessage>) => {
            state = {
                alertType: "danger",
                icon: "exclamation-circle",
                alertMessage: {
                    message: action?.payload.message,
                    showAfterRedirect: action?.payload.showAfterRedirect
                }
            };
            return state;
        },
        info: (state, action: PayloadAction<AlertMessage>) => {
            state = {
                alertType: "info",
                icon: "info-circle",
                alertMessage: {
                    message: action?.payload.message,
                    showAfterRedirect: action?.payload.showAfterRedirect
                }
            };
            return state;
        },
        warning: (state, action: PayloadAction<AlertMessage>) => {
            state = {
                alertType: "warning",
                icon: "exclamation-triangle",
                alertMessage: {
                    message: action?.payload.message,
                    showAfterRedirect: action?.payload.showAfterRedirect
                }
            };
            return state;
        },
        clear: (state) => {
            if (state?.alertMessage.showAfterRedirect) state.alertMessage.showAfterRedirect = false;
            else state = null;

            return state;
        }
    }
});

export const successAlert = (alertMessage: AlertMessage) => (dispatch: any) => {
    dispatch(success(alertMessage));
};

export const warningAlert = (alertMessage: AlertMessage) => (dispatch: any) => {
    dispatch(warning(alertMessage));
};

export const infoAlert = (alertMessage: AlertMessage) => (dispatch: any) => {
    dispatch(info(alertMessage));
};

export const dangerAlert = (alertMessage: AlertMessage) => (dispatch: any) => {
    dispatch(danger(alertMessage));
};

export const alertActions = { ...alertSlice.actions };
export const { success, warning, danger, info, clear } = alertSlice.actions;
export const alertReducer = alertSlice.reducer;
export const selectAlert = (state: RootState) => state.alert;